import { lazy, Suspense } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Layout } from './components/Layout';
import { ErrorBoundary } from './components/ErrorBoundary';
import { ErrorState } from './components/states/ErrorState';
import { LoadingState } from './components/states/LoadingState';
import { AuthProvider } from './context/AuthContext';
import { AuthGuard } from './components/auth/AuthGuard';
import './i18n';

const LoginPage = lazy(() =>
  import('./components/LoginPage').then((module) => ({ default: module.LoginPage }))
);

const SessionListPage = lazy(() =>
  import('./components/sessions/SessionListPage').then((module) => ({ default: module.SessionListPage }))
);

const SessionTasksPage = lazy(() =>
  import('./pages/SessionTasksPage').then((module) => ({ default: module.SessionTasksPage }))
);

const TaskDetailPage = lazy(() =>
  import('./components/taskDetail/TaskDetailPage').then((module) => ({ default: module.TaskDetailPage }))
);

const ViewerPage = lazy(() =>
  import('./components/taskDetail/ViewerPage').then((module) => ({ default: module.ViewerPage }))
);

const DetailsPage = lazy(() =>
  import('./components/taskDetail/DetailsPage').then((module) => ({ default: module.DetailsPage }))
);

const ReviewPage = lazy(() =>
  import('./components/taskDetail/ReviewPage').then((module) => ({ default: module.ReviewPage }))
);

export const App = () => {
  return (
    <AuthProvider>
      <Suspense fallback={<LoadingState message="Loading portal shell…" />}>
        <ErrorBoundary fallback={<ErrorState title="Portal unavailable" message="Please refresh the page or contact support." />}>
          <Routes>
            <Route path="/login" element={<LoginPage />} />
            <Route
              path="/tasks"
              element={
                <AuthGuard>
                  <Layout>
                    <SessionListPage />
                  </Layout>
                </AuthGuard>
              }
            />
            <Route
              path="/sessions"
              element={
                <AuthGuard>
                  <Layout>
                    <SessionListPage />
                  </Layout>
                </AuthGuard>
              }
            />
            <Route
              path="/sessions/:sessionId/tasks"
              element={
                <AuthGuard>
                  <Layout>
                    <SessionTasksPage />
                  </Layout>
                </AuthGuard>
              }
            />
            <Route
              path="/tasks/:taskId/*"
              element={
                <AuthGuard>
                  <TaskDetailPage />
                </AuthGuard>
              }
            >
              <Route index element={<ViewerPage />} />
              <Route path="details" element={<DetailsPage />} />
              <Route path="review" element={<ReviewPage />} />
            </Route>
            <Route path="/" element={<Navigate to="/tasks" replace />} />
            <Route path="*" element={<Navigate to="/tasks" replace />} />
          </Routes>
        </ErrorBoundary>
      </Suspense>
      <ToastContainer position="bottom-right" autoClose={4000} newestOnTop closeOnClick pauseOnHover={false} />
    </AuthProvider>
  );
};

export default App;
